import { HeroType } from "../../utils";
import { HeroPension } from "./HeroPension";

const AdviceChanged = () => {
  return <HeroPension type={HeroType.AdviceChanged} />;
};

export { AdviceChanged };
